"use strict";
angular.module("weixinRouterModule", []).
config(["$stateProvider", "$urlRouterProvider", function($stateProvider, $urlRouterProvider) {
    $stateProvider.state("front.editctr.weixin", {
        url: '/weixin',
        views: {
            "weixin@front.editctr": {
                templateUrl: './editingCenter/weixin/left_tpl.html',
                controller: 'weixinLeftCtrl'
            }
        }
    });
}]);